// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.items-display {
  display: block;
}
@media only screen and (max-width: 1100px) {
  .items-display {
    margin: 0 calc(var(--spacing) * -0.5);
  }
}
.items-display__header {
  padding: 0 calc(var(--spacing) * 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing);
}
.items-display__header .results {
  line-height: calc(var(--spacing) * 2);
}
.items-display__header .header-controls {
  display: flex;
  align-items: center;
  gap: calc(var(--spacing) * 0.5);
  flex-wrap: wrap;
}
.items-display__header .header-controls .view-toggle {
  display: flex;
  gap: calc(var(--spacing) * 0.25);
}
.items-display__header .header-controls .view-toggle .view-button {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 6px;
  --padding-bottom: 6px;
  min-width: 36px;
  min-height: 36px;
}
.items-display__header .header-controls .view-toggle .view-button ion-icon {
  font-size: 18px;
}
.items-display__footer {
  width: 100%;
  margin: calc(var(--spacing) * 2) 0 var(--spacing) 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.items-display__content.cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
@media only screen and (max-width: 1400px) {
  .items-display__content {
    grid-template-columns: 1fr 1fr;
  }
}
@media only screen and (max-width: 600px) {
  .items-display__content {
    grid-template-columns: 1fr;
  }
}
@media only screen and (min-width: 1900px) {
  .items-display__content {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (min-width: 2200px) {
  .items-display__content {
    grid-template-columns: repeat(6, 1fr);
  }
}
.items-display__content .no-results {
  padding: calc(var(--spacing) * 0.5);
}

.calendar-view {
  padding: calc(var(--spacing) * 0.5);
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
  width: 100%;
}
.calendar-view .calendar-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(var(--spacing) * 0.5);
  padding: 0 calc(var(--spacing) * 0.5);
  flex-shrink: 0;
}
.calendar-view .calendar-navigation h3 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
}
.calendar-view .calendar-navigation ion-button {
  --padding-start: 8px;
  --padding-end: 8px;
}
.calendar-view .time-schedule {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  position: relative;
}
.calendar-view .time-schedule .no-tours {
  font-size: 0.9rem;
  text-align: center;
  padding: calc(var(--spacing) * 2);
  font-style: italic;
}
.calendar-view .week-header {
  position: sticky;
  top: 0;
  z-index: 10;
  display: grid;
  grid-template-columns: 80px 1fr;
  background-color: var(--ion-color-light-tint);
  border-bottom: 1px solid var(--ion-color-light-shade);
}
@media only screen and (max-width: 768px) {
  .calendar-view .week-header {
    grid-template-columns: 60px 1fr;
  }
}
.calendar-view .week-header .week-days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
}
@media only screen and (max-width: 1200px) {
  .calendar-view .week-header .week-days-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (max-width: 768px) {
  .calendar-view .week-header .week-days-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 480px) {
  .calendar-view .week-header .week-days-grid {
    grid-template-columns: 1fr;
  }
}
.calendar-view .week-header .week-days-grid .week-day-header {
  padding: calc(var(--spacing) * 0.5);
  text-align: center;
}
.calendar-view .week-header .week-days-grid .week-day-header .day-name {
  font-weight: 600;
  font-size: 0.85rem;
  display: block;
  color: var(--ion-color-dark);
}
.calendar-view .week-header .week-days-grid .week-day-header .day-date {
  font-size: 0.75rem;
  color: var(--ion-color-dark);
  display: block;
  margin-top: 2px;
}
@media only screen and (max-width: 768px) {
  .calendar-view .week-header .week-days-grid .week-day-header {
    padding: calc(var(--spacing) * 0.25);
  }
  .calendar-view .week-header .week-days-grid .week-day-header .day-name {
    font-size: 0.75rem;
  }
  .calendar-view .week-header .week-days-grid .week-day-header .day-date {
    font-size: 0.65rem;
  }
}
.calendar-view .time-row {
  border-bottom: 1px solid var(--ion-color-light-shade);
  display: grid;
  grid-template-columns: 80px 1fr;
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row {
    grid-template-columns: 60px 1fr;
  }
}
.calendar-view .time-row:last-child {
  border-bottom: none;
}
.calendar-view .time-row .time-label-column {
  padding: calc(var(--spacing) * 0.5);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-right: 1px solid var(--ion-color-light-shade);
  min-height: 120px;
  white-space: nowrap;
}
.calendar-view .time-row .time-label-column .time-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ion-color-primary);
  writing-mode: horizontal-tb;
  text-align: center;
  margin-top: calc(var(--spacing) * 0.25);
  position: sticky;
  top: 65px;
  z-index: 5;
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .time-label-column .time-text {
    font-size: 0.8rem;
    top: 55px;
  }
}
.calendar-view .time-row .days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  padding: calc(var(--spacing) * 0.25);
}
@media only screen and (max-width: 1200px) {
  .calendar-view .time-row .days-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .days-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 480px) {
  .calendar-view .time-row .days-grid {
    grid-template-columns: 1fr;
  }
}
.calendar-view .time-row .day-column {
  display: flex;
  flex-direction: column;
  min-height: 120px;
}
.calendar-view .time-row .day-column .day-tours {
  flex: 1;
  padding: calc(var(--spacing) * 0.25);
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing) * 0.5);
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .day-column .day-tours {
    padding: calc(var(--spacing) * 0.2);
    gap: calc(var(--spacing) * 0.2);
  }
}
.calendar-view .time-row .day-column .day-tours .no-day-tours {
  font-size: 0.7rem;
  color: var(--ion-color-medium);
  text-align: center;
  font-style: italic;
  padding: calc(var(--spacing) * 0.5);
}
.calendar-view .time-row .day-column .day-tours .tour-card {
  border: 1px solid var(--ion-color-light-shade);
  border-radius: 4px;
  padding: calc(var(--spacing) * 0.25);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background-color: var(--ion-color-light-tint);
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .day-column .day-tours .tour-card {
    padding: calc(var(--spacing) * 0.2);
    font-size: 0.7rem;
  }
}
.calendar-view .time-row .day-column .day-tours .tour-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.calendar-view .time-row .day-column .day-tours .tour-card .tour-title {
  font-weight: bold;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 0.75rem;
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .day-column .day-tours .tour-card .tour-title {
    font-size: 0.7rem;
    -webkit-line-clamp: 1;
    line-clamp: 1;
  }
}
.calendar-view .time-row .day-column .day-tours .tour-card .tour-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  gap: 4px;
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .day-column .day-tours .tour-card .tour-details {
    font-size: 0.6rem;
    gap: 2px;
  }
}
.calendar-view .time-row .day-column .day-tours .tour-card .tour-details .location {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.calendar-view .time-row .day-column .day-tours .tour-card .tour-details .price {
  font-weight: bold;
  white-space: nowrap;
}
.calendar-view .time-row .day-column .day-tours .tour-card .tour-availability {
  font-size: 0.6rem;
  text-align: right;
  color: var(--ion-color-medium);
}
@media only screen and (max-width: 768px) {
  .calendar-view .time-row .day-column .day-tours .tour-card .tour-availability {
    font-size: 0.55rem;
  }
}

@media only screen and (max-width: 768px) {
  .items-display__header {
    flex-direction: column;
    align-items: stretch;
    gap: calc(var(--spacing) * 0.5);
  }
  .items-display__header .header-controls {
    justify-content: space-between;
  }
  .items-display__header .header-controls .view-toggle {
    gap: calc(var(--spacing) * 0.2);
  }
  .items-display__header .header-controls .view-toggle .view-button {
    min-width: 32px;
    min-height: 32px;
  }
  .items-display__header .header-controls .view-toggle .view-button ion-icon {
    font-size: 16px;
  }
  .calendar-view {
    height: calc(100vh - 160px);
  }
  .calendar-view .calendar-navigation h3 {
    font-size: 0.9rem;
  }
  .calendar-view .time-schedule .time-row .time-label-column {
    padding: calc(var(--spacing) * 0.25);
  }
  .calendar-view .time-schedule .time-row .time-label-column .time-text {
    font-size: 0.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/filter-items-display/filter-items-display.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EAHJ;IAIQ,qCAAA;EAEN;AACF;AAAI;EACI,qCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAER;AAAQ;EACI,qCAAA;AAEZ;AACQ;EACI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AACZ;AACY;EACI,aAAA;EACA,gCAAA;AAChB;AACgB;EACI,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AACpB;AACoB;EACI,eAAA;AACxB;AAMI;EACI,WAAA;EACA,mDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AASQ;EACI,aAAA;EACA,qCAAA;AAPZ;AAUQ;EAPJ;IAQQ,8BAAA;EAPV;AACF;AASQ;EAXJ;IAYQ,0BAAA;EANV;AACF;AAQQ;EAfJ;IAgBQ,qCAAA;EALV;AACF;AAOQ;EAnBJ;IAoBQ,qCAAA;EAJV;AACF;AAMQ;EACI,mCAAA;AAJZ;;AAUA;EACI,mCAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAPJ;AASI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yCAAA;EACA,qCAAA;EACA,cAAA;AAPR;AASQ;EACI,SAAA;EACA,iBAAA;EACA,gBAAA;AAPZ;AAUQ;EACI,oBAAA;EACA,kBAAA;AARZ;AAYI;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAVR;AAYQ;EACI,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;AAVZ;AAcI;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,6CAAA;EACA,qDAAA;AAZR;AAeQ;EAVJ;IAWQ,+BAAA;EAZV;AACF;AAcQ;EACI,aAAA;EACA,qCAAA;EACA,QAAA;AAZZ;AAcY;EALJ;IAMQ,qCAAA;EAXd;AACF;AAaY;EATJ;IAUQ,qCAAA;EAVd;AACF;AAYY;EAbJ;IAcQ,0BAAA;EATd;AACF;AAWY;EACI,mCAAA;EACA,kBAAA;AAThB;AAYgB;EACI,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,4BAAA;AAVpB;AAagB;EACI,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AAXpB;AAcgB;EAnBJ;IAoBQ,oCAAA;EAXlB;EAakB;IACI,kBAAA;EAXtB;EAckB;IACI,kBAAA;EAZtB;AACF;AAkBI;EACI,qDAAA;EACA,aAAA;EACA,+BAAA;AAhBR;AAkBQ;EALJ;IAMQ,+BAAA;EAfV;AACF;AAiBQ;EACI,mBAAA;AAfZ;AAkBQ;EAEI,mCAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,oDAAA;EACA,iBAAA;EACA,mBAAA;AAjBZ;AAmBY;EACI,iBAAA;EACA,gBAAA;EACA,+BAAA;EACA,2BAAA;EACA,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAjBhB;AAmBgB;EAXJ;IAYQ,iBAAA;IACA,SAAA;EAhBlB;AACF;AAoBQ;EACI,aAAA;EACA,qCAAA;EACA,QAAA;EACA,oCAAA;AAlBZ;AAoBY;EANJ;IAOQ,qCAAA;EAjBd;AACF;AAmBY;EAVJ;IAWQ,qCAAA;EAhBd;AACF;AAkBY;EAdJ;IAeQ,0BAAA;EAfd;AACF;AAkBQ;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AAhBZ;AAkBY;EACI,OAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;AAhBhB;AAkBgB;EAPJ;IAQQ,mCAAA;IACA,+BAAA;EAflB;AACF;AAiBgB;EACI,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;AAfpB;AAkBgB;EACI,8CAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,6CAAA;AAhBpB;AAkBoB;EAVJ;IAWQ,mCAAA;IACA,iBAAA;EAftB;AACF;AAiBoB;EACI,2BAAA;EACA,0CAAA;AAfxB;AAkBoB;EACI,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AAhBxB;AAkBwB;EAVJ;IAWQ,iBAAA;IACA,qBAAA;IACA,aAAA;EAf1B;AACF;AAkBoB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;AAhBxB;AAkBwB;EAPJ;IAQQ,iBAAA;IACA,QAAA;EAf1B;AACF;AAiBwB;EACI,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAf5B;AAkBwB;EACI,iBAAA;EACA,mBAAA;AAhB5B;AAoBoB;EACI,iBAAA;EACA,iBAAA;EACA,8BAAA;AAlBxB;AAoBwB;EALJ;IAMQ,kBAAA;EAjB1B;AACF;;AA0BA;EAEQ;IACI,sBAAA;IACA,oBAAA;IACA,+BAAA;EAxBV;EA0BU;IACI,8BAAA;EAxBd;EA0Bc;IACI,+BAAA;EAxBlB;EA0BkB;IACI,eAAA;IACA,gBAAA;EAxBtB;EA0BsB;IACI,eAAA;EAxB1B;EAgCE;IACI,2BAAA;EA9BN;EAiCU;IACI,iBAAA;EA/Bd;EAqCc;IACI,oCAAA;EAnClB;EAqCkB;IACI,iBAAA;EAnCtB;AACF","sourcesContent":[".items-display {\n    display: block;\n\n    @media only screen and (max-width: 1100px) {\n        margin: 0 calc(var(--spacing) * -.5);\n    }\n    \n    &__header {\n        padding: 0 calc(var(--spacing) * .5);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: var(--spacing);\n\n        .results {\n            line-height: calc(var(--spacing) * 2);\n        }\n\n        .header-controls {\n            display: flex;\n            align-items: center;\n            gap: calc(var(--spacing) * .5);\n            flex-wrap: wrap;\n\n            .view-toggle {\n                display: flex;\n                gap: calc(var(--spacing) * .25);\n                \n                .view-button {\n                    --padding-start: 8px;\n                    --padding-end: 8px;\n                    --padding-top: 6px;\n                    --padding-bottom: 6px;\n                    min-width: 36px;\n                    min-height: 36px;\n                    \n                    ion-icon {\n                        font-size: 18px;\n                    }\n                }\n            }\n        }\n    }\n\n    &__footer {\n        width: 100%;\n        margin: calc(var(--spacing) * 2) 0 var(--spacing) 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    \n    &__content {\n\n        &.cards{\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n        }\n        \n        @media only screen and (max-width: 1400px) {\n            grid-template-columns: 1fr 1fr;\n        }\n        \n        @media only screen and (max-width: 600px) {\n            grid-template-columns: 1fr;\n        }\n\n        @media only screen and (min-width: 1900px) {\n            grid-template-columns: repeat(4, 1fr);\n        }\n\n        @media only screen and (min-width: 2200px) {\n            grid-template-columns: repeat(6, 1fr);\n        }\n\n        .no-results {\n            padding: calc(var(--spacing) * .5);\n        }\n    }\n}\n\n// Calendar View Styles\n.calendar-view {\n    padding: calc(var(--spacing) * .5);\n    height: calc(100vh - 140px); // Use most of viewport height\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    .calendar-navigation {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: calc(var(--spacing) * .5);\n        padding: 0 calc(var(--spacing) * .5);\n        flex-shrink: 0;\n\n        h3 {\n            margin: 0;\n            font-size: 1.2rem;\n            font-weight: 600;\n        }\n\n        ion-button {\n            --padding-start: 8px;\n            --padding-end: 8px;\n        }\n    }\n\n    .time-schedule {\n        flex: 1;\n        overflow-y: auto;\n        min-height: 0;\n        position: relative;\n        \n        .no-tours {\n            font-size: 0.9rem;\n            text-align: center;\n            padding: calc(var(--spacing) * 2);\n            font-style: italic;\n        }\n    }\n\n    .week-header {\n        position: sticky;\n        top: 0;\n        z-index: 10;\n        display: grid;\n        grid-template-columns: 80px 1fr;\n        background-color: var(--ion-color-light-tint);\n        border-bottom: 1px solid var(--ion-color-light-shade);\n        //border-bottom: 2px solid var(--ion-color-primary);\n\n        @media only screen and (max-width: 768px) {\n            grid-template-columns: 60px 1fr;\n        }\n\n        .week-days-grid {\n            display: grid;\n            grid-template-columns: repeat(7, 1fr);\n            gap: 1px;\n\n            @media only screen and (max-width: 1200px) {\n                grid-template-columns: repeat(4, 1fr);\n            }\n\n            @media only screen and (max-width: 768px) {\n                grid-template-columns: repeat(2, 1fr);\n            }\n\n            @media only screen and (max-width: 480px) {\n                grid-template-columns: 1fr;\n            }\n\n            .week-day-header {\n                padding: calc(var(--spacing) * .5);\n                text-align: center;\n                //border-right: 1px solid var(--ion-color-light-shade);\n\n                .day-name {\n                    font-weight: 600;\n                    font-size: 0.85rem;\n                    display: block;\n                    color: var(--ion-color-dark);\n                }\n\n                .day-date {\n                    font-size: 0.75rem;\n                    color: var(--ion-color-dark);\n                    display: block;\n                    margin-top: 2px;\n                }\n\n                @media only screen and (max-width: 768px) {\n                    padding: calc(var(--spacing) * .25);\n                    \n                    .day-name {\n                        font-size: 0.75rem;\n                    }\n                    \n                    .day-date {\n                        font-size: 0.65rem;\n                    }\n                }\n            }\n        }\n    }\n\n    .time-row {\n        border-bottom: 1px solid var(--ion-color-light-shade);\n        display: grid;\n        grid-template-columns: 80px 1fr;\n        \n        @media only screen and (max-width: 768px) {\n            grid-template-columns: 60px 1fr;\n        }\n        \n        &:last-child {\n            border-bottom: none;\n        }\n\n        .time-label-column {\n            //background-color: var(--ion-color-light-tint);\n            padding: calc(var(--spacing) * .5);\n            display: flex;\n            align-items: flex-start;\n            justify-content: center;\n            border-right: 1px solid var(--ion-color-light-shade);\n            min-height: 120px;\n            white-space: nowrap;\n\n            .time-text {\n                font-size: 0.9rem;\n                font-weight: 600;\n                color: var(--ion-color-primary);\n                writing-mode: horizontal-tb;\n                text-align: center;\n                margin-top: calc(var(--spacing) * .25);\n                position: sticky;\n                top: 65px; // Position below week-header\n                z-index: 5;\n                \n                @media only screen and (max-width: 768px) {\n                    font-size: 0.8rem;\n                    top: 55px; // Adjust for mobile week-header height\n                }\n            }\n        }\n\n        .days-grid {\n            display: grid;\n            grid-template-columns: repeat(7, 1fr);\n            gap: 1px;\n            padding: calc(var(--spacing) * .25);\n\n            @media only screen and (max-width: 1200px) {\n                grid-template-columns: repeat(4, 1fr);\n            }\n\n            @media only screen and (max-width: 768px) {\n                grid-template-columns: repeat(2, 1fr);\n            }\n\n            @media only screen and (max-width: 480px) {\n                grid-template-columns: 1fr;\n            }\n        }\n\n        .day-column {\n            display: flex;\n            flex-direction: column;\n            min-height: 120px;\n\n            .day-tours {\n                flex: 1;\n                padding: calc(var(--spacing) * .25);\n                display: flex;\n                flex-direction: column;\n                gap: calc(var(--spacing) * .5);\n\n                @media only screen and (max-width: 768px) {\n                    padding: calc(var(--spacing) * .2);\n                    gap: calc(var(--spacing) * .2);\n                }\n\n                .no-day-tours {\n                    font-size: 0.7rem;\n                    color: var(--ion-color-medium);\n                    text-align: center;\n                    font-style: italic;\n                    padding: calc(var(--spacing) * .5);\n                }\n\n                .tour-card {\n                    border: 1px solid var(--ion-color-light-shade);\n                    border-radius: 4px;\n                    padding: calc(var(--spacing) * .25);\n                    cursor: pointer;\n                    transition: all 0.2s ease;\n                    font-size: 0.75rem;\n                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n                    background-color: var(--ion-color-light-tint);\n\n                    @media only screen and (max-width: 768px) {\n                        padding: calc(var(--spacing) * .2);\n                        font-size: 0.7rem;\n                    }\n\n                    &:hover {\n                        transform: translateY(-4px);\n                        box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n                    }\n\n                    .tour-title {\n                        font-weight: bold;\n                        margin-bottom: 4px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                        font-size: 0.75rem;\n\n                        @media only screen and (max-width: 768px) {\n                            font-size: 0.7rem;\n                            -webkit-line-clamp: 1;\n                            line-clamp: 1;\n                        }\n                    }\n\n                    .tour-details {\n                        display: flex;\n                        justify-content: space-between;\n                        align-items: center;\n                        margin-bottom: 2px;\n                        gap: 4px;\n\n                        @media only screen and (max-width: 768px) {\n                            font-size: 0.6rem;\n                            gap: 2px;\n                        }\n\n                        .location {\n                            flex: 1;\n                            overflow: hidden;\n                            text-overflow: ellipsis;\n                            white-space: nowrap;\n                        }\n\n                        .price {\n                            font-weight: bold;\n                            white-space: nowrap;\n                        }\n                    }\n\n                    .tour-availability {\n                        font-size: 0.6rem;\n                        text-align: right;\n                        color: var(--ion-color-medium);\n                        \n                        @media only screen and (max-width: 768px) {\n                            font-size: 0.55rem;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Responsive adjustments for mobile\n@media only screen and (max-width: 768px) {\n    .items-display {\n        &__header {\n            flex-direction: column;\n            align-items: stretch;\n            gap: calc(var(--spacing) * .5);\n\n            .header-controls {\n                justify-content: space-between;\n                \n                .view-toggle {\n                    gap: calc(var(--spacing) * .2);\n                    \n                    .view-button {\n                        min-width: 32px;\n                        min-height: 32px;\n                        \n                        ion-icon {\n                            font-size: 16px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .calendar-view {\n        height: calc(100vh - 160px); // Adjust for mobile header\n        \n        .calendar-navigation {\n            h3 {\n                font-size: 0.9rem;\n            }\n        }\n        \n        .time-schedule {\n            .time-row {\n                .time-label-column {\n                    padding: calc(var(--spacing) * .25);\n                    \n                    .time-text {\n                        font-size: 0.8rem;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
